import ToggleEmploymentFormButton from '@my-pages/features/employment/components/ToggleEmploymentFormButton.tsx';
import { IEmploymentInfo } from '@shared/integrations/taf-api/v2/models';
import CurrentEmployment from '@my-pages/features/employment/components/Employment/CurrentEmployment.tsx';
import UpcomingEmployment from '@my-pages/features/employment/components/Employment/UpcomingEmployment.tsx';

interface IEmploymentsProps {
    onClickChange: () => void;
    currentEmployments?: IEmploymentInfo[] | null;
    nextEmployments?: IEmploymentInfo[] | null;
}

const Employments = ({ currentEmployments, nextEmployments, onClickChange }: IEmploymentsProps) => {
    return (
        <div className='card card-body mb-4'>
            <div className='row'>
                <div className='col-md-12'>
                    <h3>Anställning</h3>
                    <div
                        className='row'
                        style={{ rowGap: '1.5rem' }}
                    >
                        {currentEmployments && currentEmployments[0] && (
                            <div className='col-12 col-md-6'>
                                <CurrentEmployment employment={currentEmployments[0]} />
                            </div>
                        )}
                        {nextEmployments && nextEmployments[0] && (
                            <div className='col-12 col-md-6'>
                                <UpcomingEmployment employment={nextEmployments[0]} />
                            </div>
                        )}
                    </div>
                    <ToggleEmploymentFormButton onClickChange={onClickChange} />
                </div>
            </div>
        </div>
    );
};

export default Employments;
